import axios from 'axios'
import { Dialog, Toast } from 'vant'
import store from '@/store'
import { getLogin, removeLogin } from '@/utils/auth'
const translate = tip => {
  if (tip === 'missing_field') {
    return "缺少字段"
  }
  if (tip === 'required') {
    return "必填"
  }
  if (tip === 'invalid') {
    return "无效字段"
  }
  if (tip === 'should be an integer') {
    return "应该是数字"
  }
  if (tip.startsWith('length should bigger than')) {
    return `应该多于 ${tip.match(/\d*$/g)[0]} 项`
  }
  if (tip.startsWith('length should smaller than')) {
    return `应该少于 ${tip.match(/\d*$/g)[0]} 项`
  }
  return ''
}
function fileToJson(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = res => {
      const { result } = res.target // 得到字符串
      const data = JSON.parse(result) // 解析成json对象
      resolve(data)
    } // 成功回调
    reader.onerror = err => {
      reject(err)
    } // 失败回调
    reader.readAsText(new Blob([file]), 'utf-8') // 按照utf-8编码解析
  })
}
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 60 * 1000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    // 请求成功
    const { status, data } = response, { message = '未知错误' } = data
    if (status !== 200) {
      // 401 未认证
      if (status === 401) {
        Dialog.confirm('您已登出请重新登录', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/logout').then(() => {
            window.location.reload()
          })
        })
      }
      return Promise.reject(new Error(message || 'Error'))
    } else {
      return data
    }
  },
  async error => {
    // 请求发生错误 往往是服务器端错误
    const { response } = error, { data, status } = response
    if (response && status === 401) {
      if (getLogin()) {
        // 有token就弹出一次token失效提示, 仅弹一次
        removeLogin()
        Toast({
          message: '登录状态已过期，请重新登录',
          type: 'error',
        });
      }
      // 跳转到登录页（避免重复跳转：判断当前页面是否已是登录页）
      window.location.href = '/';
    }
    if (status === 422) {
      const { code, field, message } = data[0]
      const detail = `${translate(code)} ${field} ${translate(message) || ""}`
      Toast({
        message: detail || '未知错误',
        type: 'error',
      })
    }
    if (data.error) {
      Toast({
        message: data.error || '未知错误',
        type: 'error',
      })
    }
    if (data.message) {
      Message.error(data.message)
    }
    if (response.config.responseType === "blob") {
      const { error } = await fileToJson(response.data)
      Toast({
        message: error || '未知错误',
        type: 'error',
        duration: 2 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export function commonRequest({ url, method = 'post', data }) {
  return service({ url, method, data })
}

export default service

